export const menuItems = [
    {
        id: 1,
        label: "menuitems.dashboards.text",
        icon: "bx-home-circle",
        link: "/manage"
    },
    {
        id: 2,
        isLayout: true
    },
    {
        id: 3,
        label: "menuitems.generaloperation.text",
        isTitle: true
    },
    {
        id: 4,
        label: "menuitems.customer.text",
        icon: "bx-user",
        link: "/manage/customer"
    },

    {
        id: 6,
        label: "menuitems.property.text",
        icon: "bx-building",
        link: "/manage/property"
    },
    {
        id: 11,
        label: "menuitems.otheroperation.text",
        isTitle: true
    },
    {
        id: 27,
        label: "menuitems.profitlost.text",
        icon: "bx-dollar-circle",
        subItems: [
            {
                id: 1,
                label: "invoice.text",
                icon: "bx-dollar-circle",
                link: "/manage/invoice"
            }, 
        {
            id: 2,
            label: "expense.text",
            icon: "bx-dollar-circle",
            link: "/manage/expense"
        }, {
            id: 3,
            label: "income.text",
            link: "/manage/income"
        }]
    },

    {
        id: 28,
        label: "setting.text",
        icon: "bx-wrench",
        link: "/manage/setting"
    },
    
    {
        id: 29,
        label: "menuitems.report.text",
        icon: "bx-file",
        link: "/manage/report"
    },

    
    
];
